import Multiselect from "multiselect-react-dropdown";
import React from "react";
import { useState, useEffect } from "react";
import DownloadReport from "../DownloadReport/DownloadReport";
import { useDispatch, useSelector } from "react-redux";
import { selectFilters, setFilters } from "../../redux/slices/filterSlice";

const Filter = ({
  noRecords,
  applyFilter,
  accountDetails,
  handleDownloadSuccess,
  handleDownloadError,
  handleDownloadRequestError,
  downloadParams,
}) => {


  const labOptions1130 = [
  {
    key: "0017labgia",
    total_amount: "$45,891,095.00",
    name: "LabGIA",
    count: 6929,
    className: "lab"
  },
  {
    key: "0018labigi",
    total_amount: "$148,362.00",
    name: "LabIGI",
    count: 150,
    className: "lab"
  }
];

const labOptionsDefault = [
  {
    key: "0000gia",
    total_amount: "$45,891,095.00",
    name: "GIA",
    count: 6929,
    className: "lab"
  },
  {
    key: "0003igi",
    total_amount: "$148,362.00",
    name: "IGI",
    count: 150,
    className: "lab"
  }
];


  const options = {
    "shape": [
      {
        "key": "0000round",
        "total_amount": "$19,760,547.00",
        "name": "Round",
        "count": 3172,
        "className": "shape"
      },
      {
        "key": "0001princess",
        "total_amount": "$1,644,190.00",
        "name": "Princess",
        "count": 350,
        "className": "shape"
      },
      {
        "key": "0002pear",
        "total_amount": "$1,058,263.50",
        "name": "Pear",
        "count": 249,
        "className": "shape"
      },
      {
        "key": "0003oval",
        "total_amount": "$10,871,571.50",
        "name": "Oval",
        "count": 1748,
        "className": "shape"
      },
      {
        "key": "0004emerald",
        "total_amount": "$4,129,166.00",
        "name": "Emerald",
        "count": 464,
        "className": "shape"
      },
      {
        "key": "0005marquise",
        "total_amount": "$2,153,050.00",
        "name": "Marquise",
        "count": 429,
        "className": "shape"
      },
      {
        "key": "0006heart",
        "total_amount": "$15,337.00",
        "name": "Heart",
        "count": 3,
        "className": "shape"
      },
      {
        "key": "0007cushion_brilliant",
        "total_amount": "$193,149.00",
        "name": "Cushion Brilliant",
        "count": 13,
        "className": "shape"
      },
      {
        "key": "0008cushion_modified",
        "total_amount": "$2,458,463.00",
        "name": "Cushion Modified",
        "count": 249,
        "className": "shape"
      },
      {
        "key": "0009radiant",
        "total_amount": "$3,689,076.00",
        "name": "Radiant",
        "count": 396,
        "className": "shape"
      },
      {
        "key": "0012square_emerald",
        "total_amount": "$20,580.00",
        "name": "Square Emerald",
        "count": 2,
        "className": "shape"
      },
      {
        "key": "0015europeancut",
        "total_amount": "$29,184.00",
        "name": "European",
        "count": 1,
        "className": "shape"
      },
      {
        "key": "0035round_modified_brilliant",
        "total_amount": "$2,693.00",
        "name": "Round Modified Brilliant",
        "count": 1,
        "className": "shape"
      },
      {
        "key": "0064other_shape",
        "total_amount": "$14,187.00",
        "name": "Other",
        "count": 2,
        "className": "shape"
      }
    ],
    "carats": [
      {
        "name": "0.40-0.49",
        "key": "0.4-0.49",
        "count": 2,
        "total_amount": "$1,485.00",
        "className": "carats"
      },
      {
        "name": "0.50-0.59",
        "key": "0.5-0.59",
        "count": 622,
        "total_amount": "$454,763.00",
        "className": "carats"
      },
      {
        "name": "0.60-0.69",
        "key": "0.6-0.69",
        "count": 164,
        "total_amount": "$147,386.00",
        "className": "carats"
      },
      {
        "name": "0.70-0.79",
        "key": "0.7-0.79",
        "count": 510,
        "total_amount": "$651,254.00",
        "className": "carats"
      },
      {
        "name": "0.80-0.89",
        "key": "0.8-0.89",
        "count": 359,
        "total_amount": "$564,205.00",
        "className": "carats"
      },
      {
        "name": "0.90-0.99",
        "key": "0.9-0.99",
        "count": 448,
        "total_amount": "$960,492.00",
        "className": "carats"
      },
      {
        "name": "1.00-1.09",
        "key": "1.0-1.09",
        "count": 1238,
        "total_amount": "$3,735,750.00",
        "className": "carats"
      },
      {
        "name": "1.10-1.19",
        "key": "1.1-1.19",
        "count": 46,
        "total_amount": "$163,753.00",
        "className": "carats"
      },
      {
        "name": "1.20-1.29",
        "key": "1.2-1.29",
        "count": 768,
        "total_amount": "$3,116,882.00",
        "className": "carats"
      },
      {
        "name": "1.30-1.39",
        "key": "1.3-1.39",
        "count": 119,
        "total_amount": "$546,674.00",
        "className": "carats"
      },
      {
        "name": "1.40-1.49",
        "key": "1.4-1.49",
        "count": 39,
        "total_amount": "$238,134.00",
        "className": "carats"
      },
      {
        "name": "1.50-1.69",
        "key": "1.5-1.69",
        "count": 852,
        "total_amount": "$5,753,902.00",
        "className": "carats"
      },
      {
        "name": "1.70-1.79",
        "key": "1.7-1.79",
        "count": 372,
        "total_amount": "$3,329,772.00",
        "className": "carats"
      },
      {
        "name": "1.80-1.89",
        "key": "1.8-1.89",
        "count": 70,
        "total_amount": "$682,681.00",
        "className": "carats"
      },
      {
        "name": "1.90-1.99",
        "key": "1.9-1.99",
        "count": 66,
        "total_amount": "$689,435.00",
        "className": "carats"
      },
      {
        "name": "2.00-2.19",
        "key": "2.0-2.19",
        "count": 759,
        "total_amount": "$8,260,768.00",
        "className": "carats"
      },
      {
        "name": "2.20-2.49",
        "key": "2.2-2.49",
        "count": 157,
        "total_amount": "$2,569,721.00",
        "className": "carats"
      },
      {
        "name": "2.50-2.69",
        "key": "2.5-2.69",
        "count": 219,
        "total_amount": "$4,217,157.00",
        "className": "carats"
      },
      {
        "name": "2.70-2.99",
        "key": "2.7-2.99",
        "count": 22,
        "total_amount": "$496,912.00",
        "className": "carats"
      },
      {
        "name": "3.00-3.19",
        "key": "3.0-3.19",
        "count": 135,
        "total_amount": "$4,039,369.00",
        "className": "carats"
      },
      {
        "name": "3.20-3.49",
        "key": "3.2-3.49",
        "count": 16,
        "total_amount": "$515,091.00",
        "className": "carats"
      },
      {
        "name": "3.50-3.69",
        "key": "3.5-3.69",
        "count": 23,
        "total_amount": "$914,988.00",
        "className": "carats"
      },
      {
        "name": "3.70-3.99",
        "key": "3.7-3.99",
        "count": 7,
        "total_amount": "$263,624.00",
        "className": "carats"
      },
      {
        "name": "4.00-4.49",
        "key": "4.0-4.49",
        "count": 36,
        "total_amount": "$1,642,738.00",
        "className": "carats"
      },
      {
        "name": "4.50-4.99",
        "key": "4.5-4.99",
        "count": 7,
        "total_amount": "$439,355.00",
        "className": "carats"
      },
      {
        "name": "5.00-5.49",
        "key": "5.0-5.49",
        "count": 16,
        "total_amount": "$1,059,405.00",
        "className": "carats"
      },
      {
        "name": "5.50-5.99",
        "key": "5.5-5.99",
        "count": 2,
        "total_amount": "$163,382.00",
        "className": "carats"
      },
      {
        "name": "6.00-6.99",
        "key": "6.0-6.99",
        "count": 3,
        "total_amount": "$281,574.00",
        "className": "carats"
      },
      {
        "name": "7.00-7.99",
        "key": "7.0-7.99",
        "count": 1,
        "total_amount": "$67,620.00",
        "className": "carats"
      },
      {
        "name": "10.00-99.99",
        "key": "10.0-99.99",
        "count": 1,
        "total_amount": "$71,185.00",
        "className": "carats"
      }
    ],
    "color": [
      {
        "name": "D",
        "key": [
          "0000d"
        ],
        "count": 429,
        "total_amount": "$3,509,307.00",
        "className": "color"
      },
      {
        "name": "E",
        "key": [
          "0001e"
        ],
        "count": 618,
        "total_amount": "$3,447,441.00",
        "className": "color"
      },
      {
        "name": "F",
        "key": [
          "0002f"
        ],
        "count": 975,
        "total_amount": "$5,681,508.00",
        "className": "color"
      },
      {
        "name": "G",
        "key": [
          "0003g"
        ],
        "count": 1572,
        "total_amount": "$9,188,695.50",
        "className": "color"
      },
      {
        "name": "H",
        "key": [
          "0004h"
        ],
        "count": 1576,
        "total_amount": "$10,155,786.00",
        "className": "color"
      },
      {
        "name": "I",
        "key": [
          "0005i"
        ],
        "count": 1142,
        "total_amount": "$7,665,805.50",
        "className": "color"
      },
      {
        "name": "J",
        "key": [
          "0006j"
        ],
        "count": 582,
        "total_amount": "$4,386,156.00",
        "className": "color"
      },
      {
        "name": "K Down",
        "key": [
          "0007k",
          "0008l",
          "0009m",
          "0010n",
          "0011o",
          "0012p",
          "0013q",
          "0014r",
          "0015s",
          "0016t",
          "0017u",
          "0018v",
          "0019w",
          "0020x",
          "0021y",
          "0022z"
        ],
        "count": 185,
        "total_amount": "$2,004,758.00",
        "className": "color"
      }
    ],
    "clarity": [
      {
        "name": "VVS+",
        "key": [
          "0000fl",
          "0001if",
          "0002vvs1",
          "0003vvs2"
        ],
        "count": 220,
        "total_amount": "$1,426,303.00",
        "className": "clarity"
      },
      {
        "name": "VS1",
        "key": [
          "0004vs1"
        ],
        "count": 675,
        "total_amount": "$4,801,668.00",
        "className": "clarity"
      },
      {
        "name": "VS2",
        "key": [
          "0005vs2"
        ],
        "count": 849,
        "total_amount": "$7,270,442.00",
        "className": "clarity"
      },
      {
        "name": "SI1",
        "key": [
          "0006si1"
        ],
        "count": 2695,
        "total_amount": "$16,502,973.50",
        "className": "clarity"
      },
      {
        "name": "SI2",
        "key": [
          "0007si2",
          "0008si3"
        ],
        "count": 2315,
        "total_amount": "$14,461,963.50",
        "className": "clarity"
      },
      {
        "name": "I",
        "key": [
          "0009i1",
          "0010p1",
          "0011i2",
          "0012p2",
          "0013i3",
          "0014p3"
        ],
        "count": 325,
        "total_amount": "$1,576,107.00",
        "className": "clarity"
      }
    ],
    "make": [
      {
        "key": "0000xxx",
        "total_amount": "$17,798,964.50",
        "name": "XXX",
        "count": 2848,
        "className": "make"
      },
      {
        "key": "0001x_vgvg_plus",
        "total_amount": "$660,991.00",
        "name": "X-VGVG+",
        "count": 108,
        "className": "make"
      },
      {
        "key": "0002vg_xx",
        "total_amount": "$13,875,145.00",
        "name": "VG-XX",
        "count": 1675,
        "className": "make"
      },
      {
        "key": "0003vg_vgvg_plus",
        "total_amount": "$11,769,629.50",
        "name": "VG-VGVG+",
        "count": 2080,
        "className": "make"
      },
      {
        "key": "0004vg_gdgd_plus",
        "total_amount": "$1,832,078.00",
        "name": "VG-GDGD+",
        "count": 345,
        "className": "make"
      },
      {
        "key": "0006gd_vgvg_plus",
        "total_amount": "$36,290.00",
        "name": "GD-VGVG+",
        "count": 4,
        "className": "make"
      },
      {
        "key": "0007gd_gdgd_plus",
        "total_amount": "$39,530.00",
        "name": "GD-GDGD+",
        "count": 6,
        "className": "make"
      },
      {
        "key": "0008unknown",
        "total_amount": "$26,829.00",
        "name": "N/A",
        "count": 13,
        "className": "make"
      }
    ],
    "fluor": [
      {
        "key": "0000none",
        "total_amount": "$25,622,097.00",
        "name": "None",
        "count": 4062,
        "className": "fluor"
      },
      {
        "key": "0001faint",
        "total_amount": "$12,997,575.50",
        "name": "Faint",
        "count": 1937,
        "className": "fluor"
      },
      {
        "key": "0002medium",
        "total_amount": "$4,688,264.50",
        "name": "Medium",
        "count": 644,
        "className": "fluor"
      },
      {
        "key": "0003strong",
        "total_amount": "$2,593,467.00",
        "name": "Strong",
        "count": 419,
        "className": "fluor"
      },
      {
        "key": "0004v_strong",
        "total_amount": "$138,053.00",
        "name": "Very Strong",
        "count": 17,
        "className": "fluor"
      }
    ],
    "lab": accountDetails == "1130"
    ? labOptions1130
    : labOptionsDefault
  }

  const dispatch = useDispatch();
  const filtersFromStore = useSelector(selectFilters);
  
  const SUMMARY_DATA_PROPERTIES = {
    lab: "diamond#cert",
    shape: "diamond#shape",
    color: "diamond#color",
    clarity: "diamond#clarity",
    carats: "gem#carats",
    milky: "diamond#milky",
    shade: "diamond#shade",
    make: "diamond#make",
    fluor: "diamond#fluor",
    bic: "diamond#black_in_center",
    bis: "diamond#black_in_side",
    wis: "diamond#white_in_side",
    wic: "diamond#white_in_center",
  };

  const [filters, setFiltersLocal] = useState(() => JSON.parse(JSON.stringify(filtersFromStore || {})));
  
  useEffect(() => {
    setFiltersLocal(JSON.parse(JSON.stringify(filtersFromStore || {})));
  }, [filtersFromStore]);

  const onSelect = (selectedList, removedItem, className) => {
    const attrName = SUMMARY_DATA_PROPERTIES[className];
    if (!attrName) return;

    // Create a new filters object
    const updatedFilters = { ...filters };

    if (selectedList?.length) {
      const filterValues = selectedList.map(option => {
        if (attrName === "gem#carats") {
          const [from, to] = option.key.split("-");
          return { from, to };
        }
        return option.key;
      });
    //  console.log("filterValues", filterValues)
      // Handle both color/clarity and other fields consistently
      if (attrName === "diamond#color" || attrName === "diamond#clarity") {
        updatedFilters[attrName] = filterValues.flat(); // Wrap in array to maintain structure
      } else {
        updatedFilters[attrName] = filterValues;
      }
    } else {
      // Remove the key if no values selected
      delete updatedFilters[attrName];
    }

    setFiltersLocal(updatedFilters);
  };

  const handleApplyFilter = () => {
    // Prepare filters for Redux and API
    const preparedFilters = Object.keys(filters).reduce((acc, key) => {
      if (filters[key]?.length) {
        if (key === "diamond#color" || key === "diamond#clarity") {
          // Ensure color and clarity maintain their structure
          acc[key] = filters[key].flat();
        } else {
          acc[key] = filters[key];
        }
      }
      return acc;
    }, {});

    // Update Redux store
    dispatch(setFilters(preparedFilters));
    
    // Call parent's apply filter
    applyFilter(preparedFilters);
  };


const renderMultiselect = (key, optionList, isNoRecords) => {
  const attrName = SUMMARY_DATA_PROPERTIES[key];
  const selectedValues = filters[attrName]
  ?.flat()
  .map((value) => {
    return optionList.find((option) => {
      if (attrName === "diamond#color" || attrName === "diamond#clarity") {
        // Color keys are arrays, check if any match
        return Array.isArray(option.key) ? option.key.includes(value) : option.key === value;
      } 
      // if (attrName === "diamond#clarity") {
      //   // Clarity should be matched by name, not key
      //   return Array.isArray(option.key) && option.key.some((val) => value.includes(val));
        
      // } 
      if (attrName === "gem#carats") {
        // Convert object `{ from, to }` into "from-to" string for comparison
        return option.key === `${value.from}-${value.to}`;
      }
      return option.key === value;
    });
    
  })
  .filter(Boolean) || [];

  const uniqueSelectedValues = selectedValues.reduce((acc, option) => {
    if (option && !acc.some((selected) => selected.name === option.name)) {
      acc.push(option);
    }
    return acc;
  }, []);


  return (
      <div className="col-sm-3" style={{ padding: "10px" }} key={key}>
          <Multiselect
              optionLabel={"Select " + key}
              onSelect={(selectedList) => onSelect(selectedList, null, key)}
              onRemove={(removedList) => onSelect(removedList, null, key)}
              className={key}
              options={optionList}
              displayValue="name"
              placeholder={"Select " + key}
              selectedValues={uniqueSelectedValues}
          />
      </div>
  );
};

  return (
    <>
      <div className="row justify-content-start border-secondary" style={{ margin: "10px" }}>
            {Object.entries(options).map(([key, optionList]) => 
                renderMultiselect(key, optionList)
            )}
      </div>
      <div className="col-lg-12" style={{}}>
        <div
          className="row"
          style={{
            justifyContent: "end",
          }}
        >
          <div style={{ marginBottom: "8px", width: "fit-content" }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleApplyFilter}
            >
              <i className=" bi bi-sliders me-1"></i> Apply Filters
            </button>
          </div>

          {/* <DownloadReport
            handleDownloadSuccess={handleDownloadSuccess}
            handleDownloadError={handleDownloadError}
            handleDownloadRequestError={handleDownloadRequestError}
            captureReportDownloadParams={downloadParams}
          /> */}
        </div>
      </div>
    </>
  );
};

export default Filter;
